/**
 * 請求管理 一括仮締め登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/requests/billing_confirms`
const sales_request_temporary_fastening = {
  namespaced: true,
  actions: {
    /**
     * 仮締め登録を行う
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  }
}
export default sales_request_temporary_fastening
